export default __webpack_public_path__ + "static/media/Meeting Krug 1.dea32c69.jpg";